import { render, staticRenderFns } from "./DavidPacheco.vue?vue&type=template&id=2b87500d&scoped=true"
import script from "./DavidPacheco.vue?vue&type=script&lang=js"
export * from "./DavidPacheco.vue?vue&type=script&lang=js"
import style0 from "./DavidPacheco.vue?vue&type=style&index=0&id=2b87500d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b87500d",
  null
  
)

export default component.exports